import { FaRegStar } from "react-icons/fa6";
import Modal, { ModalContent } from "../../elements/Modal";
import { BiHide, BiTrash } from "react-icons/bi";

type MealType = {
  id: number;
  name: string;
  category: string;
  restaurant: string;
  description: string;
  image: string;
  lastUpdated: string;
  price: number;
  rating: number;
  orders: number;
  status: string;
};

const MealModal = ({
  toggleModal,
  meal,
}: {
  toggleModal: () => void;
  meal: MealType | null;
}) => {
  return (
    <Modal
      open={true}
      onClose={toggleModal}
      className="flex items-center justify-center"
    >
      <ModalContent className="mx-3 p-6 rounded-md shadow-lg flex flex-col  bg-white w-[80%] md:w-[45%] lg:w-[40%] xl:w-[50%] font-mont">
        <h1 className="font-semibold text-2xl text-secondary pb-3">
          {meal?.name}
        </h1>
        <p className="text-gray-500">Menu item details and management</p>
        <section className="h-[30rem] overflow-y-auto px-4">
          <section className="flex items-center justify-between gap-4">
            <figure className="w-80 h-72">
              <img src={meal?.image} alt={meal?.name} />
            </figure>
            <section className="w-3/5 flex items-start justify-between">
              <article className="flex flex-col gap-4">
                <div>
                  <h3 className="text-lg font-medium">Category:</h3>
                  <p className="text-gray-500">{meal?.category}</p>
                </div>
                <div>
                  <h3 className="text-lg font-medium">Price:</h3>
                  <p className="text-gray-500">N{meal?.price}</p>
                </div>
                <div>
                  <h3 className="text-lg font-medium">Restaurant:</h3>
                  <p className="text-secondary">{meal?.restaurant}</p>
                </div>
              </article>
              <article className="flex flex-col gap-4">
                <div>
                  <h3 className="text-lg font-medium">Status:</h3>
                  <p className="text-secondary capitalize">{meal?.status}</p>
                </div>
                <div>
                  <h3 className="text-lg font-medium">Ratings:</h3>
                  <p className="flex items-center gap-1 text-gray-500">
                    {meal?.rating} <FaRegStar className="text-orange100" />{" "}
                    Based off {meal?.orders} reviews
                  </p>
                </div>
              </article>
            </section>
          </section>
          <section>
            <article>
              <h3 className="text-lg font-medium">Description</h3>
              <p className="text-gray-500">{meal?.description}</p>
            </article>
            <article className="flex items-center gap-10 bg-gray-100 mt-4 p-5">
              <div>
                <h3 className="font-medium text-lg">Total Orders</h3>
                <p className="text-gray-500 text-sm">{meal?.orders}</p>
              </div>
              <div>
                <h3 className="font-medium text-lg">Last Updated</h3>
                <p className="text-gray-500 text-sm">{meal?.lastUpdated}</p>
              </div>
            </article>
          </section>
          <section className="mt-6 flex items-center justify-end gap-6 pt-4">
            <button
              type="button"
              className="p-2 flex items-center w-48 justify-center gap-3 bg-gray-100 text-gray-500 hover:bg-gray-300 transition-colors duration-700"
            >
              <BiHide /> Hide Item
            </button>
            <button
              type="button"
              className="p-2 flex items-center w-48 justify-center gap-3 bg-[#EA19191F] text-[#EA1919] hover:bg-[#EA19192F] transition-colors duration-700"
            >
              <BiTrash /> Delete Item
            </button>
          </section>
        </section>
      </ModalContent>
    </Modal>
  );
};

export default MealModal;
